import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	placeHolder: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.name.place-holder',
		defaultMessage: 'Enter the SLA name...',
		description: 'place holder for sla textField',
	},
	emptyMetricName: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.name.empty-metric-name',
		defaultMessage: 'Metric name is required',
		description: 'validation message displayed for empty metric name',
	},
	chooseMetricName: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.name.choose-metric-name',
		defaultMessage:
			'You can only choose from suggested metric names. If you want to create new ones, please contact your Jira administrator.',
		description: 'helper message displayed to select metric name',
	},
	createNew: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.name.create-new',
		defaultMessage: '{newName} (New SLA)',
		description: 'label for create new',
	},
	newName: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.name.new-name',
		defaultMessage: 'Select metric name',
		description: 'label for select metric name input field',
	},
});
